<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>新增统计</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button v-permisaction="['config:userLoginAct:export']" icon="el-icon-download" size="mini" @click="exportData(5)">导出</el-button>
          </el-form-item>
        </el-form>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />

      </el-card>

      <el-card>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
          />
          <el-table-column
            prop="reg_count"
            label="新增用户"
          />
          <el-table-column
            prop="adInstall"
            label="广告安装"
          />
          <el-table-column
            prop="invite_reg"
            label="邀请数"
          />
          <el-table-column
            prop="user_naturally"
            label="自然量"
          />
          <el-table-column
            prop="log_count"
            label="活跃用户"
          />
        </el-table>
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { exportStatData, getActStat } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UserLoginStat',
  data() {
    return {
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      loading: false,
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      getActStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.data
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const loginData = res.data.data
          const regCount = []
          const adInstallCount = []
          const naturallyCount = []
          const inviteCount = []
          const loginCount = []
          this.date = []
          loginData.forEach((item, index) => {
            this.date.push(dateStrTodate(item.date))
            regCount.push(item.reg_count)
            adInstallCount.push(item.adInstall)
            inviteCount.push(item.invite_reg)
            naturallyCount.push(item.user_naturally)
            loginCount.push(item.log_count)
          })

          this.option.xAxis.data = this.date
          this.option.series[0].data = regCount
          this.option.series[1].data = adInstallCount
          this.option.series[2].data = inviteCount
          this.option.series[3].data = naturallyCount
          this.option.series[4].data = loginCount
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        // title: {
        //   text: '活跃统计'
        // },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['新增用户', '广告安装', '邀请数', '自然量', '活跃用户'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}人' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '新增用户',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}人' // 显示数值
            }
          },
          {
            name: '广告安装',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}人' // 显示数值
            }
          },
          {
            name: '邀请数',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}人' // 显示数值
            }
          },
          {
            name: '自然量',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}人' // 显示数值
            }
          },
          {
            name: '活跃用户',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}人' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    exportData(typ) {
      exportStatData({ startDate: this.queryParams.startDate, endDate: this.queryParams.endDate, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
